import React, { Component,useEffect,useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable,{defaultThemes} from 'react-data-table-component';
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HTMLParserComponent from "../HTMLParserComponent.js";
import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import '../preloading.css';




import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const ManageSalary = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;

	// function getDate() {
	// 	const today = new Date();
	// 	const month = today.getMonth() + 1;
	// 	const year = today.getFullYear();
	// 	const date = today.getDate();
	// 	return `${year}-${month}-${date}`;
	//   }

	const today = new Date().toISOString().split("T")[0];


	const [user, setUser] = useState({
        employee_id: "0",
        department_id:"0",
    })


      const [department, setDepartmentValue] = useState("0");
      const [employeeDropdownOptions,setEmployeeDropdownOptions]=useState([]);
      const [employeedet,setEmployeeValue] = useState("0");
	  const [showDownload, setShowDownload] = useState(true);
	  const { sortConfig, sortData, handleSort } = useSortData();
     
     
      const handleFirstDropdownChange = (event) => {
         const value = event.target.value;

        //  alert(value);
         setDepartmentValue(value);
     
         // Trigger API call based on the selected value
         fetchSecondDropdownOptions(value);
       };
     
     
          // Fetch options for the second dropdown
         const fetchSecondDropdownOptions = async (selectedValue) => {
     
          try {
          
        const response = await fetch(
              API_BASE_URL + '/showdeptbase_all_emp/'+selectedValue, {
                headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
            }
            ); // Replace with your API URL
       
            const data = await response.json();
            console.log(data);
     
            setEmployeeDropdownOptions(data); // Assuming the API returns an array of options
          } catch (error) {
            console.error("Error fetching second dropdown options:", error);
          }
        };
     
     
          // Handle second dropdown change
          const handleSecondDropdownChange = (event) => {
            // setSecondDropdownValue(event.target.value);
            setEmployeeValue(event.target.value);
          };
	

	
	const history = useHistory();
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
	const [attnlist, setattnlist]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);


    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

    
    }

    const [shiftcode,setShiftCodeValue]= useState("");
	const [officeshift,setOfficeShift]= useState([]);

	const handleShift = (event) => {
	const value = event.target.value;
	setShiftCodeValue(value);

	
  };


  		const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [entriesPerPage,setEntriesPerPage]=useState(10);
		const safe = (val) => String(val ?? "").toLowerCase();

const searchableFields = [
  "employee_id",
  "employee_name",
  "department_name",
  "designation_name",
  "basic_salary",
  "gross_salary",
  "net_take",
];

const filteredItems =
  searchTerm.trim() === ""
    ? records
    : records.filter((item) =>
        searchableFields.some((field) =>
          safe(item[field]).includes(searchTerm.toLowerCase())
        )
      );

		const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
    const indexOfLast = currentPage * entriesPerPage;
    const indexOfFirst = indexOfLast - entriesPerPage;
    // const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);
	const sortedItems = sortData(filteredItems);
	const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);
	  
		useEffect(() => {
		  setCurrentPage(1);
		}, [searchTerm]);
	  
		const paginate = (pageNumber) => setCurrentPage(pageNumber);
	
	  const handleSearch = (event) => {
		//console.log(event.target.value);
		 setSearchTerm(event.target.value);
	  };
	
	//   const handleRowsPerPageChange = (e) => {
	// 	setItemsPerPage(Number(e.target.value));
	// 	setCurrentPage(1); // Reset to first page
	//   };


	const clearInput = () => {
		setSearchTerm("");
	  };


      const handleDepartment = async () => {
	  
        axios.get(API_BASE_URL +'/showdepartment/', { headers : {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${localStorage.getItem("authToken")}`
       }})
        .then(res1 => setdataval(res1.data))
        .catch(err => console.log(err))
       };
  
  
       useEffect(() => {
        handleDepartment();
      }, []);



	  const handleShiftCode = async () => {

	axios.get(API_BASE_URL + '/read_shift_info', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})
//    .then(res1 => console.log(res1.data))
	.then(res1 => setOfficeShift(res1.data))
	.catch(err => console.log(err))
   };

    useEffect(() => {
	handleShiftCode();
	 }, []);


const handleDownload = async () => {
  try {
    const response = await axios.get(API_BASE_URL + '/salaryfitment', {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });

    if (response.data.lnk) {
      toast.success("Report generated successfully!");
      window.open(response.data.lnk, "_blank"); // open download
    } else {
      toast.error("No data found!");
    }
  } catch (error) {
    console.error(error);
    toast.error("Error generating report!");
  }
};





const handleSubmit = async (e) => {
    e.preventDefault();
	setLoading(true);

	// alert(user.start_date);
	// alert(user.department);
    try {
      const response = await axios.post(API_BASE_URL +'/managesalary',
		{ department_id: department, employee_id: employeedet }, 
		{
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}

);
console.log(response.data.managesalary);
      setRecords(response.data.managesalary); // Assuming the API response contains the records in `response.data`
	  setLoading(false);
	} catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  


  useEffect(()=> {
	axios.post(API_BASE_URL +'/managesalary',{ department_id: department, employee_id: employeedet }, {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

    // .then(response =>console.log(response.data.shiftattendance))
	 .then(response => setRecords(response.data.managesalary))
	.catch(err => console.log(err));
},[])




const columns = [
	{ label: "Emp Id", key: "employee_id", sortable: true },
	{ label: "Name", key: "employee_name", sortable: true },
  { label: "Department", key: "department_name", sortable: true },
  { label: "Designation", key: "designation_name", sortable: true },
  { label: "Basic Salary", key: "basic_salary", sortable: true },
  { label: "Allowance", key: "allowance", sortable: true },
  { label: "Gross Salary", key: "gross_salary", sortable: true },
  { label: "Deduction", key: "deduction", sortable: true },
  { label: "CTC", key: "ctc", sortable: true },
  { label: "Net Salary", key: "net_take", sortable: true },
   { label: "Hostel", key: "hostel", sortable: true },
   { label: "Other Info", key: "other", sortable: true },
];



	return (
		<>
			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

						<ToastContainer/>


						</div>


						
					</div>


                    <div className="section-body mt-3">
					<div className="container-fluid">
						<div className="row clearfix">
							<div className="col-md-12">
								<div className="card">
									<div className="card-header d-flex justify-content-between align-items-center">
										<h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
											<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
												<path d="M4 3.06h2.726c1.22 0 2.12.575 2.325 1.724H4v1.051h5.051C8.855 7.001 8 7.558 6.788 7.558H4v1.317L8.437 14h1.844L5.5 8.677c2.148 0 3.523-1.212 3.65-2.842H12v-1.05h-2.851c-.191-.638-.51-1.156-.951-1.501H12V1H4z"/>
											</svg>
											Manage Salary
										</h3>
									</div>
									{/* <div className="card-header">
										<h3 className="card-title">My Shift</h3>
									</div> */}
									<div className="card-body">
										 <form onSubmit={handleSubmit}> 

                                            <div class="row">

											

                                    <div className="col-md-3 col-sm-6">
									<div className="form-group">
									<label className="form-label">Department</label>
									{(() => {
										const deptOptions = [
											{ value: "0", label: "All Department" },
											...dataval.map((o) => ({ value: o.department_id, label: o.department_name })),
										];
										return (
											<Select
												isSearchable={true}
												placeholder="Search Department..."
												options={deptOptions}
												styles={{ menu: (base) => ({ ...base, zIndex: 9999 }), menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
												menuPortalTarget={typeof document !== "undefined" ? document.body : null}
												value={deptOptions.find((o) => o.value == department) || deptOptions[0]}
												onChange={(opt) => handleFirstDropdownChange({ target: { value: opt ? opt.value : "0" } })}
											/>
										);
									})()}
														</div>
                                    </div>
                                    
							

								
								


                                <div className="col-md-3 col-sm-6">
									<div className="form-group">
									<label className="form-label">Employee</label>
                                        {(() => {
                                        	const empOptions = [
                                        		{ value: "0", label: "All Employee" },
                                        		...employeeDropdownOptions.map((o) => ({ value: o.user_id, label: `${o.first_name} ${o.last_name}` })),
                                        	];
                                        	return (
                                        		<Select
                                        			isSearchable={true}
                                        			placeholder="Search Employee..."
                                        			options={empOptions}
                                        			styles={{ menu: (base) => ({ ...base, zIndex: 9999 }), menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                        			menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                                        			isDisabled={employeeDropdownOptions.length === 0}
                                        			value={empOptions.find((o) => o.value == employeedet) || empOptions[0]}
                                        			onChange={(opt) => handleSecondDropdownChange({ target: { value: opt ? opt.value : "0" } })}
                                        		/>
                                        	);
                                        })()}

                                                        </div>

                                                         </div>

                                 <div className="col-md-3 col-sm-6">
									<div className="form-group">
                                <label className="form-label" style={{ visibility: "hidden", display: "block" }}>Action</label>
                                <button type="submit" className="btn btn-primary">
								GET
							</button>&nbsp;&nbsp;

							 <button
        type="button"
        className="btn btn-primary"
        onClick={handleDownload}
      >
        Download
      </button>

							
                            </div>
                            </div>

							

							{/* {showDownload && ( */}
  {/* <div className="col-md-3 col-sm-6">
    <div className="form-group">
      <button
        type="button"
        className="btn btn-success"
        onClick={handleDownload}
      >
        Download
      </button>
    </div>
  </div> */}
{/* )} */}

							

							
                            
                           



                            </div>

                            
                               

                                           


										
	
										
											
										 </form>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>









					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">

										<div className="card-header">
											<div
  className="card-options"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>
  <EntriesSelector
    entriesPerPage={entriesPerPage}
    setEntriesPerPage={setEntriesPerPage}
    setCurrentPage={setCurrentPage}
  />

  {/* 🔽 SEARCH BOX WRAPPER */}
  <div style={{ position: "relative", width: "200px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "100%",
        height: "30px",
        fontSize: "13px",
        borderRadius: "4px",
        paddingRight: "28px", // ✅ space for X
      }}
    />

    {searchTerm.length > 0 && (
      <span
        onClick={clearInput}
        style={{
          position: "absolute",
          right: "8px",        // ✅ INSIDE input
          top: "50%",          // ✅ vertically centered
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#aaa",
          fontSize: "16px",
          userSelect: "none",
        }}
      >
        ✖
      </span>
    )}
  </div>
</div>
										</div>


{loading && (
											<div className="card-body">
											<div class="d-flex justify-content-center">
       <div class="spinner"></div>
	   </div>
	   </div>
      )}

{!loading && (
										<div className="card-body">
										
											<div className="table-responsive sticky-table-wrap" style={{ maxHeight: "440px", overflowY: "auto" }}>




			<table className="table table-hover table-striped table-vcenter text-nowrap mb-0 sticky-table" style={{ borderCollapse: "separate", borderSpacing: 0 }}>
													<thead>
														<tr>
                                                            {columns.map((col) => (
																<th
																	key={col.key}
																	onClick={col.sortable ? () => handleSort(col.key) : null}
																	style={{
																		cursor: col.sortable ? "pointer" : "default",
																		position: "sticky",
																		top: 0,
																		zIndex: 5,
																		background: "#fff",
																		boxShadow: "inset 0 -1px 0 #dee2e6",
																	}}
																>
																	{col.label}
																	{col.sortable && (
																sortConfig.key === col.key
																	? (sortConfig.direction === "asc" ? " ▲" : " ▼")
																	: " ⇅"   // <-- DEFAULT SORT ICON
																)}
																	</th>
																))}
                                                            
															
														</tr>
													</thead>
													<tbody>
														{/* {console.log(records)} */}
													{records.length > 0 ? (
															filteredData.map((record) => {

															
															return(
															<tr key={record.employee_id}>
																
																<td>{record.employee_id}</td>
																<td>{record.employee_name}</td>
																<td>{record.department_name}</td>
                                                                <td>{record.designation_name}</td>
                                                                <td>{record.basic_salary}</td>
																<td>{ReactHtmlParser(record.allowance)}</td>
																<td>{record.gross_salary}</td>
                                                                <td>{ReactHtmlParser(record.deduction)}</td>
																<td>{ReactHtmlParser(record.ctc)}</td>
                                                                <td>{record.net_take}</td>
                                                                <td>{record.hostel}</td>
																<td>{ReactHtmlParser(record.other)}</td>
																
															</tr>
															)
})
														) : (
															<tr>
															<td colSpan="12" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
															</tr>
														)}

											
													</tbody>
												</table>
											</div>
										
			<Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />			
								

										</div> 
)
}
									</div>
								</div>
	
							
							</div>
						</div>
					</div>

				</div>
			</div> 

										
			


			
			


			

		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(ManageSalary);